// Collapse / expand sidebar subgroups. Lightens the integrator section which
// otherwise stacks 14+ rows. State persisted to localStorage per-group so
// an operator's preference survives reload.

const STORE_KEY = 'apx-admin:sidebar-collapsed';

function loadCollapsed(): Set<string> {
  try {
    const raw = localStorage.getItem(STORE_KEY);
    if (!raw) return new Set();
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? new Set(arr.filter((s) => typeof s === 'string')) : new Set();
  } catch {
    return new Set();
  }
}

function saveCollapsed(set: Set<string>): void {
  try {
    localStorage.setItem(STORE_KEY, JSON.stringify(Array.from(set)));
  } catch {
    /* private mode — fine */
  }
}

export function installSidebarCollapse(): void {
  const collapsed = loadCollapsed();

  document.querySelectorAll<HTMLElement>('.sidebar [data-subgroup]').forEach((header) => {
    const key = header.dataset.subgroup!;
    const body = header.nextElementSibling as HTMLElement | null;
    if (!body || !body.classList.contains('sidebar-subgroup-body')) return;

    const apply = (isCollapsed: boolean): void => {
      header.classList.toggle('collapsed', isCollapsed);
      body.classList.toggle('hidden', isCollapsed);
      header.setAttribute('aria-expanded', String(!isCollapsed));
    };

    apply(collapsed.has(key));

    header.addEventListener('click', () => {
      if (collapsed.has(key)) collapsed.delete(key);
      else collapsed.add(key);
      saveCollapsed(collapsed);
      apply(collapsed.has(key));
    });
  });
}
